export const zoomIntegrationActionTypes = {
    /*
     * Zoom connect constants
     */
    CONNECT_ZOOM_INTEGRATION_REQUEST: 'INTEGRATIONS_CONNECT_ZOOM_REQUEST',
    CONNECT_ZOOM_INTEGRATION_SUCCESS: 'INTEGRATIONS_CONNECT_ZOOM_SUCCESS',
    CONNECT_ZOOM_INTEGRATION_FAILURE: 'INTEGRATIONS_CONNECT_ZOOM_FAILURE',

    /*
     * Zoom Re-connect constant
     */
    RE_CONNECT_ZOOM_INTEGRATION_INDICATOR: 'INTEGRATIONS_RE_CONNECT_ZOOM_INDICATOR',

    /*
     * Zoom disconnect constants
     */
    DISCONNECT_ZOOM_INTEGRATION_REQUEST: 'INTEGRATIONS_DISCONNECT_ZOOM_REQUEST',
    DISCONNECT_ZOOM_INTEGRATION_SUCCESS: 'INTEGRATIONS_DISCONNECT_ZOOM_SUCCESS',
    DISCONNECT_ZOOM_INTEGRATION_FAILURE: 'INTEGRATIONS_DISCONNECT_ZOOM_FAILURE',

    /*
     * Zoom get recordings constants
     */
    RECORDINGS_ZOOM_INTEGRATION_REQUEST: 'INTEGRATIONS_RECORDINGS_ZOOM_REQUEST',
    RECORDINGS_ZOOM_INTEGRATION_SUCCESS: 'INTEGRATIONS_RECORDINGS_ZOOM_SUCCESS',
    RECORDINGS_ZOOM_INTEGRATION_FAILURE: 'INTEGRATIONS_RECORDINGS_ZOOM_FAILURE',

	/**
	 * Zoom (analytics-related) action types
	 */
	ZOOM_MEETING_EXPAND             : "ZOOM_MEETING_EXPAND",
	ZOOM_MEETING_COLLAPSE           : "ZOOM_MEETING_COLLAPSE",
	ZOOM_MEETING_RECORDING_PREVIEW  : "ZOOM_MEETING_RECORDING_PREVIEW",
};
